<script>
  import Vue from 'vue'
  import api from '../api'
  import swal from 'sweetalert'
  import UserForm from '../components/UserForm'

  export default {

    components: {
      UserForm
    },  
    
    data () {
      return {
        data: {},
        validation: {},
        loading: false
      }
    },

    methods: {
      async create (data) {
        
        this.loading = true

        try {
          let response = await api.apios.post('/api/users', data)
          this.data = {}
        }
        catch (err) {
          this.validation = err.response.data.errors
          return
        }
        finally {
          this.loading = false
        }

        swal({
          title: 'User Created',
          showCancelButton: true,
          confirmButtonText: 'Back to Users',
          cancelButtonText: 'Add Another'
        }, (confirmed => confirmed && this.$router.push('/users')))

      }
    }
  }
</script>

<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Create User</h1>
      <h2 class="subtitle">They will have access to the system.</h2>
      <hr />

      <div class="columns">
        <div class="column is-half">
          <user-form @submit="create" :validation="validation" :data="data" :loading="loading"></user-form>
        </div>
      </div>
    </div>
  </section>
</template>